/*
 * @Author: Jing
 * @Date: 2021-12-24 14:38:13
 * @Descripttion:
 */
import { Loading, Dialog, Notify, Icon, Toast, Button, Popup, List, Field, RadioGroup, Radio, Cascader, Tabbar, TabbarItem, DatetimePicker, Switch, Col, Row, Tab, Tabs, Checkbox, CheckboxGroup, Sticky, Picker, ImagePreview, SwipeCell, Tag, Search, DropdownMenu, DropdownItem, Badge } from 'vant'

const components = [Icon, Button, Popup, List, Field, RadioGroup, Radio, Cascader, Tabbar, TabbarItem, DatetimePicker, Switch, Col, Row, Tab, Tabs, Checkbox, CheckboxGroup, Sticky, Picker, ImagePreview, SwipeCell, Tag, Search, DropdownMenu, DropdownItem, Badge]

const plugins = [Loading, Dialog, Notify, Toast, ImagePreview]

export default (app: any) => {
    components.forEach((component) => {
        app.component(component.name, component)
    })

    plugins.forEach((plugin) => {
        app.use(plugin)
    })
}
